<template>
    <div class="rules">
        <div class="rules__title">
            <h1>{{ getTranslatedText("Fafi Rules") }}</h1>
        </div>
        <div class="rules-box">
            <p class="rules-box-title">{{ getTranslatedText("overview") }}:</p>
            <p class="rules-box-text">
                <b>{{ getTranslatedText("Number Selection:") }}</b>
                {{ getTranslatedText("Players select numbers from 1 to 36, each of which is associated with a symbol or picture. Players can choose one or more numbers, and the amount of money they can win is based on the odds of the numbers selected.") }}
            </p>
            <p class="rules-box-text">
                <b>{{ getTranslatedText("Betting:") }}</b>
                {{ getTranslatedText("Players place their bets with a Fafi operator or bookmaker. The amount of money that can be bet and the odds for each number can vary from one operator to another.") }}
            </p>
            <p class="rules-box-text">
                <b>{{ getTranslatedText("Drawing:") }}</b>
                {{ getTranslatedText("The winning number is drawn either randomly by the operator, or it may be based on some external event, like the last two digits of the closing price of a stock exchange, or other publicly available numbers.") }}
            </p>
            <p class="rules-box-text">
                <b>{{ getTranslatedText("Winnings:") }}</b>
                {{ getTranslatedText("Players win if the number they selected is drawn. The amount of money won is based on the odds for the selected number and the amount of money bet.") }}
            </p>
            <p class="rules-box-text">
                <b>{{ getTranslatedText("Payouts:") }}</b>
                {{ getTranslatedText("The operator pays out the winnings to the players who selected the winning number.") }}
            </p>
            <p class="rules-box-title">{{ getTranslatedText("General") }}:</p>
            <p class="rules-box-text">
                {{ getTranslatedText("All Fafi bets for a specific draw or instant game must be placed and confirmed before the draw cutoff, as well as before the first number is drawn for the wagered bet.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("If for any reason a bet is placed after the first number is drawn, the wagers will be voided and the full stake will be refunded.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("If a draw time is rescheduled, the draw will be cancelled, and all affected wagers will be refunded. A new draw may be introduced with the re-scheduled time slot.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("Numbers drawn shall be obtained in accordance with the certified RNG. If any mistakes and/or alternative submissions are submitted.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("All wagers that cannot be settled for any reason will be voided and refunded.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("All Fafi betting markets are fixed odds bets, with one outcome, a win or a loss. No consolation prizes are offered for any draws and/or markets. All of the selected numbers drawn must match the wager entry in any order.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("For a successful wager, the player must select the correct image or correlation number for 1-36, before the Fafi draw has its first ball drawn or the cutoff countdown has expired, after which the results must be published correctly. Following the publishing of valid results, all wager payouts will be paid directly to the player account wallet.") }}
            </p>
            <p class="rules-box-text">
                {{ getTranslatedText("If any of the draws expire before the wager is finalized, these wagers may be moved to the next available draw by the player or they can be cancelled.") }}
            </p>
        </div>
    </div>
</template>
<script>
import languageMixins from "@/mixins/language/language-mixins"

export default {
    mixins: [languageMixins],
}
</script>

<style lang="scss">
@import "~ThemePath/scss/rules/index.scss";
</style>
